import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoginService } from '../login/login.service';
import { User } from '../models/user';
import { ParameterConst } from '../util/constant';


@Component({
  selector: 'wr-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {


  welcome;
  nombreRol;
  date:Date;
  menus =[];
  @Input() public linkActive: string;

  constructor( private router : Router, private _loginService: LoginService) { 
    this.linkActive = this.router.url
   setInterval(() => {
    this.date = new Date()
  }, 1000)
  }

  ngOnInit() {

    let user = new User();
    user = JSON.parse(localStorage.getItem(ParameterConst.USER_LOGIN));
    this.menus = JSON.parse(localStorage.getItem(ParameterConst.USER_MENU));
    
    if(user){   
     // this.nombreRol = localStorage.getItem(ParameterConst.USER_ROL);
      this.welcome = user.clientName;
    }

    

  }



  obtenerNombre() {
    try {

    } catch (error) {
      return "";
    }
  }
  background = '';
  toggleBackground() {
    this.background = this.background ? '' : 'primary';
  }
  onUsuario(){
  }

  changePassword(){

  }

  cerrarSesion(){
    this._loginService.logout();
    this.router.navigate(['/']);

  }
}
